
    import {
        Component,
        Emit,
        namespace,
        Prop,
        Vue,
        Watch
    } from 'nuxt-property-decorator';

    const entities = namespace('entities');

    interface ITagGroup {
        id: string;
        _id: string;
        options: {
            name: string;
            tags: ITag[];
        };
    }

    interface ITag {
        name: string;
        slug: string;
    }

    @Component
    export default class OptionsFieldsTag extends Vue {
        @Prop() value!: any;
        @entities.Action fetchAll;

        tagsGroups: ITagGroup[] = [];
        selectedGroup: string = this.value.tagGroupId || '';
        tags: ITag[] = [];
        selectedTag: ITag[] | string = this.value.tag || '';

        async created() {
            this.tagsGroups = await this.fetchAll('tags');
            this.updateTags();
        }

        @Watch('selectedGroup')
        updateTags() {
            const group =
                this.tagsGroups &&
                this.tagsGroups.find(({ id }) => id === this.selectedGroup);

            if (group) {
                this.tags = group.options.tags;
            } else {
                this.tags = [];
                this.selectedTag = '';
            }
        }

        @Emit('input')
        setValue() {
            return { tag: this.selectedTag, tagGroupId: this.selectedGroup };
        }
    }
